import { getFormattedDateTime } from './getFormattedDateTime'
import { InputDate } from './types/inputDate'

export const getFormattedDate = (
  date?: InputDate,
  locale?: string,
  inputOptions?: Omit<Intl.DateTimeFormatOptions, 'timeStyle'>,
): string => {
  const options: Intl.DateTimeFormatOptions = {
    ...(!inputOptions?.dateStyle
      ? {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }
      : {}),
    ...(inputOptions || {}),
    timeStyle: undefined,
  }

  return getFormattedDateTime(date, locale, options)
}
